<template>
  <div class="cost reimbursement-type">
    <div class="reimbursement-type-container">
      <div class="left-container">
        <type-tree 
          :list="list"
          :listId="id"
          :type="type"
          @selectTreeNodeList="selectTreeNodeList"
        />
      </div>
      <div class="container" v-if="id">
        <div class="phone">
          <div class="inset-phone" v-if="title">
            <div class="title">
              <div class="title-name">
                <p v-if="isMod">{{ title }}</p>
                <el-input ref="customerInput" v-else class="gray white" v-model="title" autofocus @blur="blur"></el-input>
              </div>
              <!-- <img src="../../../assets/mod.png" @click="mod"> -->
            </div>
            <div class="row">
              <div class="sub-title">
                <span>费用类型</span>
                <span class="star">*</span>
              </div>
              <div class="phone-content">
                <span>请选择</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="row" v-if="costType === 3">
              <div class="sub-title">
                <span>日期</span>
                <span class="star">*</span>
              </div>
              <div class="phone-content">
                <span>请选择</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="row" v-if="costType === 3">
              <div class="sub-title">
                <span>开支内容</span>
                <span class="star">*</span>
              </div>
              <div class="phone-content">
                <span>请输入</span>
              </div>
            </div>
            <div class="row">
              <div class="sub-title">
                <span>金额</span>
                <span class="star">*</span>
              </div>
              <div class="phone-content">
                <span>请输入</span>
              </div>
            </div>
            <div class="add" v-if="costType === 2">
              <div class="add-row">
                <div class="row">
                  <div class="sub-title">
                    <span>人数</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>天数</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
              </div>
              <div class="add-row">
                <div class="row">
                  <div class="sub-title">
                    <span>标准</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>金额（元）</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请输入</span>
                  </div>
                </div>
              </div>
              <!-- <div class="cost-details">
                <span>+新增</span>
              </div> -->
            </div>
            <div class="total">
              <div class="row">
                <div class="sub-title">
                  <span>发票</span>
                  <span v-if="ruleForm.checked" class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请选择</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="upload-invoice">
                <i class="el-icon-plus"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-container" v-if="id && !isFoodSubsidyOrCityTransportationFee">
        <div class="tip">
          1.此表单只生效与单个费用类型，如果需要其他费用类型的表单，请选择其他费用类型新建表单。
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item label="发票可选" prop="checked">
            <el-checkbox v-model="ruleForm.checked" @change="changeInvoiceCheck">必填</el-checkbox>
          </el-form-item>
          <el-form-item label="发票识别" prop="invoice">
            <el-select v-model="ruleForm.invoice" multiple placeholder="请选择">
              <el-option
                v-for="item in invoiceList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="foot-container" v-if="id && OPERATION_LIST.findIndex(
            (item) => item === OPERATIONS_BTNS.roleUpdateBillForm
          ) !== -1">
        <el-button class="btn-blue" type="primary" @click="save('ruleForm')">保存</el-button>
      </div>
          
      <div v-if="!id" class="nothing">
        <div>
          <div>
            <img src="../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Tree from '@/components/Tree.vue'
import TypeTree from '@/components/type-tree.vue'
import BillAdmin from "@/models/bill-admin.js";
import { mapId } from "@/common/js/utils.js";
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [operationMixins],
  components: {
    Tree,
    TypeTree
  },

  data() {
    return {
      list: [],
      id: 0,
      type: 3,
      title: '',
      isMod: true,
      ruleForm: {
        checked: true,
        invoice: null
      },
      rules: {
        invoice: [{ required: true, message: "请选择发票", trigger: "change" }],
      },
      invoiceList: [],
      isSearch: false,
      costType: null,
      /* 是否是市内交通费和伙食补助 */
      isFoodSubsidyOrCityTransportationFee: false
    }
  },

  created() {
    config()
    this.initCostTypeList()
    this.initInvoiceList()
  },

  methods: {
    initCostTypeList() {
      BillAdmin.getCostTypeList().then(res => {
        if (res.success) {
          let arr = this.mapChild(res.result);
          this.list = mapId(arr, this.id)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取发票类型 */
    initInvoiceList() {
      BillAdmin.getInvoiceTypeList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.invoiceList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取详情 */
    initDetails() {
      let billType = this.id
      BillAdmin.getCostDetailsList(billType).then(res => {
        if (res.success) {
          if (res.result) {
            if (res.result.name) this.title = res.result.name
            this.id = res.result.billTypeId
            this.ruleForm.checked = res.result.receiptRequest ? true : false
            this.ruleForm.invoice = res.result.receiptTypeList
          } else {
            this.ruleForm.checked = true
            this.ruleForm.invoice = null
          }
          this.rules.invoice[0].required = this.ruleForm.checked
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    
    mapChild(child) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        obj.id = value.id;
        obj.label = value.name;
        obj.type = value.type;
        obj.level = value.level;
        obj.parentId = value.parentId;
        obj.keyword = value.keyword;
        if (value.billTypeList && value.billTypeList.length > 0) {
          obj.children = this.mapChild(value.billTypeList);
        } else {
          obj.children = [];
        }
        arr.push(obj);
      });
      return arr;
    },

    selectTreeNodeList(v) {
      if (v.level > 2) {
        this.costType = v.type
        this.title = v.label
        this.id = v.id
        let arr = ['Food_Subsidy', 'City_Transportation_Fee']
        if (arr.indexOf(v.keyword) != -1) {
          this.isFoodSubsidyOrCityTransportationFee = true
        } else {
          this.isFoodSubsidyOrCityTransportationFee = false
        }
        this.initDetails()
      } else {
        this.id = ''
      }
    },

    mod() {
      this.isMod = false
      this.$nextTick(function () {
        this.$refs.customerInput.$el.querySelector('input').focus();
      });
    },

    blur() {
      this.isMod = true
    },

    save(formName) {
      if (!this.isFoodSubsidyOrCityTransportationFee) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitFnc()
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.submitFnc()
      }
    },

    submitFnc() {
      let billTypeId = this.id
      let name = this.title
      let receiptRequest = this.ruleForm.checked ? 1 : 0
      let receiptTypeList = this.ruleForm.invoice
      let data = {
        billTypeId,
        name,
        receiptRequest,
        receiptTypeList
      }
      BillAdmin.postModCost(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '保存成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    changeInvoiceCheck(v) {
      this.rules.invoice[0].required = v
    }
  }
}
</script>

<style lang='scss' scoped>
.nothing {
  position: absolute;
  left: 60%;
  top: 50%;
  img {
    width: 157px;
    height: 157px;
  }
  p {
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-LightGrey;
    margin-top: 24px;
  }
}
</style>
